<ng-container *ngIf="page">
  <ng-container *ngIf="isEditMode">
    <div edsGrid>
      <div edsRow>
        <h5>
          Legal Caveats Component<span *ngIf="placement">
            - {{ placement }}</span
          >
        </h5>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="placement || directCaveats?.length">
    <div edsGrid>
      <div edsRow>
        <div
          edsCol
          [attr.id]="
            importantLegalTitle?.length ? 'important-legal-info' : null
          "
        >
          <eds-legal
            *ngIf="legals?.length"
            [title]="importantLegalTitle"
            [hasSection]="true"
          >
            <ng-container *ngIf="isSiteIntl">
              <div
                class="legal-caveats__container"
                [class.small]="isSmallLegalCaveats"
                *ngFor="let paragraph of legals"
                [innerHTML]="paragraph"
              ></div>
            </ng-container>
            <ng-container *ngIf="!isSiteIntl">
              <div
                *ngFor="let paragraph of legals"
                [innerHTML]="paragraph"
                class="small"
              ></div>
            </ng-container>
          </eds-legal>

          <eds-legal *ngIf="footnotes?.length" [title]="footnotesTitle">
            <ol class="list--ordered" *ngIf="isSiteIntl">
              <li
                *ngFor="let footnote of footnotes; let i = index"
                [innerHTML]="footnote"
                id="footnote{{ i + 1 }}"
                edsListItem
              ></li>
            </ol>
            <ol class="list--ordered" *ngIf="!isSiteIntl">
              <li
                *ngFor="let footnote of footnotes; let i = index"
                [innerHTML]="footnote"
                edsListItem
                id="footnote{{ i + 1 }}"
                class="small"
              ></li>
            </ol>
          </eds-legal>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
